import React, { useState, useEffect, useRef } from 'react';
import validator from 'validator';
import Header from './Header';

const SignatureGenerator = () => {
	const [name, setName] = useState('');
	const [role, setRole] = useState('');
	const [email, setEmail] = useState('');
	const [phone, setPhone] = useState('');
	const [cellphone, setcellPhone] = useState('');
	const [copied, setCopied] = useState(false);
	const [isFormValid, setIsFormValid] = useState(false);
	const signatureRef = useRef(null);
	const maildomain = '@creativart.it';

	useEffect(() => {
		const firstName = name.trim().split(' ')[0];
		const prepopulatedEmail = firstName
			? firstName.toLowerCase() + maildomain
			: '';
		setEmail(prepopulatedEmail);
	}, [name]);

	useEffect(() => {
		const signatureHTML = generateSignature();
		if (signatureRef.current) {
			signatureRef.current.innerHTML = signatureHTML;
		}
	}, [name, role, email, phone, cellphone]);

	useEffect(() => {
		const isValid = validateForm();
		setIsFormValid(isValid);
	}, [name, role, email]);

	const copySignature = () => {
		const signatureElement = document.querySelector('#signature');
		const range = document.createRange();
		range.selectNodeContents(signatureElement);
		const selection = window.getSelection();
		selection.removeAllRanges();
		selection.addRange(range);

		try {
			document.execCommand('copy');
			setCopied(true);
			setTimeout(() => {
				setCopied(false);
			}, 2000);
		} catch (error) {
			console.error('Errore durante la copia della firma', error);
		}

		selection.removeAllRanges();
	};

	const generateSignature = () => {
		const formattedRole = role.replace(/\n/g, '<br>');

		let formattedPhone = phone;
		if (phone && !phone.includes('+39')) {
			const normalizedPhone = phone.replace(/\s/g, ''); // Rimuovi tutti gli spazi dal numero di telefono
			formattedPhone = '+39' + normalizedPhone;
		}
		let formattedcellPhone = cellphone;

		if (cellphone && !cellphone.includes('+39')) {
			const normalizedcellPhone = cellphone.replace(/\s/g, ''); // Rimuovi tutti gli spazi dal numero di telefono
			formattedcellPhone = '+39' + normalizedcellPhone;
		}

		const phoneContent = formattedPhone;
		const cellphoneContent = formattedcellPhone;

		let signatureHTML = `
        <div id="signature"><table border="0" cellspacing="0" cellpadding="0" width="450" style="font-size:small;width:450px;min-width:450px;margin-top:15px; line-height:12px !important; font-family:sans-serif">
          <tbody>
            <tr valign="top">
              <td valign="top" style="width:10px;padding-left:5px;padding-top:5px;min-width:100px;width:100px;margin-right:15px" width="100">
                <img src="${
									process.env.PUBLIC_URL
								}/logo.jpg" width="80" height="80" title="Creativart snc" alt="Creativart" style="border-radius:50%;min-width:80px;min-height:80px;width:80px;height:80px;margin-top:20px;border:solid thin gainsboro">
              </td>
              <td style="margin-right:15px">&nbsp;</td>
              <td valign="top" align="left" id="content" style="font-family:"Nunito Sans", Verdana, Helvetica, sans-serif;text-align:left;font-stretch:normal;font-size:14px;color:rgb(32,32,32);padding:0px 10px 10px 0;line-height:14px">
                <div id="name" style="font-size:15px;line-height:24px;color:#CD2A3C;display:block;font-weight:600"><br><strong>${
									name ? name : 'Nome Cognome'
								}</strong><br></div>
                <div id="posizione" style="font-size:13px;line-height:16px;color:rgb(32,32,32)"><span style="color:rgb(77,77,77);">${formattedRole}</span></div>
                <br>
                <div style="color:rgb(32,32,32);font-size:12px;line-height:16px">
                  <span style="display:inline-block;font-weight:600;font-size:13px" id="email"><a style="color:rgb(32,32,32);text-decoration:none" href="mailto:${
										email ? email : '#'}">${email ? email : 'nome' + maildomain}</a></span>`;

		if (cellphone) {
			signatureHTML += `<span id="cell"><br>Mobile:&nbsp;<a href="tel:${cellphoneContent}" style="color:rgb(32,32,32)!important;text-decoration:none" target="_blank">${cellphone}</a></span>`;
		}
		if (phone) {
			signatureHTML += `<span id="diretto"><br>Diretto:&nbsp;<a href="tel:${phoneContent}" style="color:rgb(32,32,32)!important;text-decoration:none" target="_blank">${phone}</a></span>`;
		}

		signatureHTML += `
              <br><br>
                  <div style="font-size:12px;color:rgb(32,32,32);line-height:16px;">
                    <strong style="font-size:13px">Creativart snc</strong><br>
                    Via Adriano Garbini, 1 - 37135 Verona<br>
                    Tel. <a href="tel:+39045953685" style="color:rgb(32,32,32)!important;text-decoration:none" target="_blank">+39 045.953685</a><br>
                    <span style="white-space:nowrap;display:inline-block;font-weight:bold"><strong style="color:rgb(32,32,32);text-decoration:none"><a href="https://www.creativart.it/" style="color:rgb(32,32,32) !important;text-decoration:none" target="_blank">www.creativart.it</a></strong></span>`;
		//signatureHTML += `<br><span style="font-size:10px">P.IVA 04322720238</span>`;
		signatureHTML += `
                <div style="margin-top:10px;width:125px;height:25px;position:relative;display:block;" id="Social">
                  <a href="https://it.linkedin.com/company/creativart-verona" style="color:rgb(17,85,204)" target="_blank"><img width="20" height="20" src="https://creativart.it/media/linkedin.png" style="border-radius:0px;border:0px;margin-right:5px;width:20px;min-height:20px;display:inline-block" alt="LinkedIn"></a>
			   <a href="https://www.instagram.com/creativart_official/" style="color:rgb(17,85,204)" target="_blank"><img width="20" height="20" src="https://creativart.it/media/instagram.png" style="border-radius:0px;border:0px;margin-right:5px;width:20px;min-height:20px;display:inline-block" alt="Instagram"></a>
			   <a href="https://www.facebook.com/CreativartWebAgency/" style="color:rgb(17,85,204)" target="_blank"><img width="20" height="20" src="https://creativart.it/media/facebook.png" style="border-radius:0px;border:0px;margin-right:5px;width:20px;min-height:20px;display:inline-block" alt="Facebook"></a>
			   <a href="https://www.youtube.com/channel/UC2e_eDcu6d11lZ5slSl7v3Q" style="color:rgb(17,85,204)" target="_blank"><img width="20" height="20" src="https://creativart.it/media/youtube.png" style="border-radius:0px;border:0px;margin-right:5px;width:20px;min-height:20px;display:inline-block" alt="YouTube"></a>
                </div>
			 </div>
                </div>
              </td>
            </tr>
          </tbody></table>
        </div>`;

		return signatureHTML;
	};

	const validateForm = () => {
		const isValidEmail = validator.isEmail(email);
		const isNameValid = name.trim() !== '';
		const isRoleValid = role.trim() !== '';
		//const isPhoneValid = phone.trim() !== '';
		//const isCellphoneValid = cellphone.trim() !== '';

		return (
			isValidEmail && isNameValid && isRoleValid /*&&
			isPhoneValid &&
			isCellphoneValid*/
		);
	};

	return (
		<>
			<Header />
			<div className="container mx-auto pt-4" style={{ maxWidth: '600px' }}>
				<div className="row mb-3">
					<label htmlFor="name" className="col-sm-4 col-form-label">
						Nome e cognome:
					</label>
					<div className="col-sm-8">
						<input
							type="text"
							className="form-control"
							id="name"
							value={name}
							required
							onChange={(e) => setName(e.target.value)}
						/>
					</div>
				</div>
				<div className="row mb-3">
					<label htmlFor="role" className="col-sm-4 col-form-label">
						Ruolo:
					</label>
					<div className="col-sm-8">
						<textarea
							type="text"
							className="form-control"
							id="role"
							value={role}
							required
							style={{ resize: 'none', height: '90px' }}
							onChange={(e) => setRole(e.target.value)}
						/>
					</div>
				</div>
				<div className="row mb-3">
					<label htmlFor="email" className="col-sm-4 col-form-label">
						Email:
					</label>
					<div className="col-sm-8">
						<input
							type="email"
							className="form-control"
							id="email"
							value={email}
							required
							onChange={(e) => setEmail(e.target.value)}
						/>
					</div>
				</div>
				<div className="row mb-3">
					<label htmlFor="phone" className="col-sm-4 col-form-label">
						Telefono:
					</label>
					<div className="col-sm-8">
						<input
							type="text"
							className="form-control"
							id="phone"
							value={phone}
							onChange={(e) => setPhone(e.target.value)}
						/>
					</div>
				</div>
				<div className="row mb-3">
					<label htmlFor="phone" className="col-sm-4 col-form-label">
						Cellulare:
					</label>
					<div className="col-sm-8">
						<input
							type="text"
							className="form-control"
							id="cellphone"
							value={cellphone}
							onChange={(e) => setcellPhone(e.target.value)}
						/>
					</div>
				</div>
				<hr className="mt-4" />
				<div dangerouslySetInnerHTML={{ __html: generateSignature() }} />
				<hr />
				<button
					className="btn btn-xl btn-primary my-4 mx-auto d-block"
					onClick={copySignature}
					disabled={!validateForm()}
				>
					{copied ? 'Copiata!' : 'Copia'}
				</button>
			</div>
		</>
	);
};

export default SignatureGenerator;
